import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, shape, string, any, func, object, bool } from "prop-types";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import ReadingList from "../ReadingList/index";
import style from "../ReadingListDownload/styles.module.scss";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import { getKingspanDrugPolicyPDF } from "../../api";
import { forceDownload } from "../../containers/ResourceFolders/util";
import oldSops from "./oldSops";

const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

const KingspanOnboarding = ({
  appData,
  readingList,
  SOPDocsLine1,
  SOPDocsLine24,
  SOPDocsLine3,
  SOPDocsShop1,
  markDocumentRead,
  kingspanOnboarding,
  SOPLoading,
  postSOPKingspan,
  kingspanReadingLoading,
  kingspanAssessmentLoading,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const [showCheckbox, setShowCheckbox] = useState("");
  const [content, showContent] = useState("");

  const testResults =
    appData.kingspanOnboarding &&
    appData.kingspanOnboarding.literacyTestResultsKingspan;

  const testSubmitted = testResults && appData.kingspanOnboarding.YKN1;

  const isFormCompleted = (typeCode) =>
    !!(appData.kingspanOnboarding && appData.kingspanOnboarding[typeCode]);

  const assessmentWithStatus = {
    status: isFormCompleted("YKN1") ? 3 : 1,
    title: "Numeracy and Literacy Test",
    text: "Complete",
    url: "kingspan-onboarding/literacy-assessment",
    downloadingDisabled: true,
    loading: kingspanAssessmentLoading,
    submitted: testSubmitted,
    disabled: kingspanAssessmentLoading,
  };

  const assessmentScore = () =>
    Object.values(testResults).reduce((a, b) => a + b.correctAnswered, 0);

  const assessmentScorePercentage = () =>
    Math.floor((assessmentScore() / 50) * 100);

  const getPDF = () => {
    getKingspanDrugPolicyPDF().then((response) => {
      forceDownload(response, "Drug & Alcohol Policy");
    });
  };

  const readDocuments =
    (kingspanOnboarding && kingspanOnboarding.readDocuments) || [];

  const SOPsLine1 =
    (kingspanOnboarding && kingspanOnboarding.SOPDocsLine1) || [];

  const SOPsLine24 =
    (kingspanOnboarding && kingspanOnboarding.SOPDocsLine24) || [];

  const SOPsLine3 =
    (kingspanOnboarding && kingspanOnboarding.SOPDocsLine3) || [];

  const SOPsShop1 =
    (kingspanOnboarding && kingspanOnboarding.SOPDocsShop1) || [];

  const readingListWithStatus = readingList
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const setSectionDocs = (line, sops) => {
    const oldVersionsOfSops = sops
      .sort((a, b) => a.title.localeCompare(b.title))
      .filter((el) => oldSops[line].includes(el.title));
    const currentVersionsOfSops = sops
      .sort((a, b) => a.title.localeCompare(b.title))
      .filter((el) => !oldSops[line].includes(el.title));
    return [...currentVersionsOfSops, ...oldVersionsOfSops];
  };

  const listOfSOps = [
    {
      line: "Line 1",
      docs: setSectionDocs("Line 1", SOPDocsLine1) || [],
      statusFor: SOPsLine1,
      formName: "line1",
    },
    {
      line: "Line 2 & 4",
      docs: setSectionDocs("Line 2 & 4", SOPDocsLine24) || [],
      statusFor: SOPsLine24,
      formName: "line24",
    },
    {
      line: "Line 3",
      docs: setSectionDocs("Line 3", SOPDocsLine3) || [],
      statusFor: SOPsLine3,
      formName: "line3",
    },
    {
      line: "Shop 1",
      docs: setSectionDocs("Shop 1", SOPDocsShop1) || [],
      statusFor: SOPsShop1,
      formName: "shop1",
    },
  ];

  useEffect(() => {}, [showCheckbox, currentlyReading]);

  const isiOSDevice = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };
  const isDownloadAttrSupported = () =>
    "download" in document.createElement("a");

  const handleReading = (event, title, link) => {
    window.open(link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      event.preventDefault();
    }
    setShowCheckbox(title);
  };

  const currentDate = new Date(Date.now());
  const handleCheckbox = (formName, el) => {
    postSOPKingspan(formName, {
      [el.title]: currentDate.toISOString(),
    });
    setShowCheckbox("");
  };

  return (
    <div className="container text-bluishGray pb-2">
      <h2 className="pt-4">Kingspan Onboarding</h2>
      <div className="row">
        <div className="col-lg-6">
          <ReadingList
            description="You are required to download and read each handbook below before you start work. You will then be asked to tick the box to confirm you have read and understood and agree to each handbook. If you have any queries about the handbooks, please speak to your line manager."
            readingListWithStatus={readingListWithStatus}
            currentlyReading={currentlyReading}
            setCurrentlyReading={setCurrentlyReading}
            markDocumentRead={markDocumentRead}
            isKingspan={true}
            isLoading={kingspanReadingLoading}
            getCompletedDocument={getPDF}
          />
        </div>
        <div className="col-lg-6 mt-lg-0 mt-2">
          <div className="section-body pt-1 mb-2 bg-white">
            <h5 className="px-1">Test</h5>
            <p className="p-1">
              Please complete the test below. If you have any queries about the
              test, please speak to your HRGO Consultant.
            </p>
            <OnboardingListItem
              title={assessmentWithStatus.title}
              status={assessmentWithStatus.status}
              btnText={assessmentWithStatus.text}
              key={assessmentWithStatus.title}
              url={assessmentWithStatus.url}
              downloadingDisabled={assessmentWithStatus.downloadingDisabled}
              loading={assessmentWithStatus.loading}
            />
          </div>
          {testSubmitted && (
            <div className="section-body bg-white py-2 my-1 mt-lg-0">
              <h5 className="px-1">Test Results</h5>
              {Object.values(testResults).map((result) => (
                <div
                  key={result.sectionNumber}
                  style={{
                    display: "flex",
                    padding: "0 1rem",
                    justifyContent: "space-between",
                  }}
                >
                  <p>Section {result.sectionNumber}</p>
                  <p>
                    {result.correctAnswered}/{result.numberOfQuestions}
                  </p>
                </div>
              ))}
              <div
                style={{
                  display: "flex",
                  padding: "0 1rem",
                  justifyContent: "space-between",
                }}
              >
                <p>
                  <b>SCORE</b>
                </p>
                <p>
                  <b>
                    {assessmentScore()}/50 = {assessmentScorePercentage()}%
                  </b>
                </p>
              </div>
              <p
                style={{
                  padding: "0 1rem",
                }}
              >
                The pass rate for this test is 70% - 35 correct questions out of
                50.
              </p>
            </div>
          )}
          <div
            className={`${style.readingList__wrapper} section-body bg-white py-2 my-2 mt-lg-0`}
          >
            <h5 className="px-1">Standard Operating Procedures (SOPs)</h5>
            <p className="px-1">
              You will be informed by your line manager or HRGO consultant what
              SOPs you must download and read, please await their instruction.
            </p>
            {listOfSOps.map((el) => (
              <Fragment key={el.formName}>
                <div
                  style={{
                    fontWeight: "700",
                    cursor: "pointer",
                    padding: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="styles__onboarding__wrapper___3a5Dz items-center flex-row mb6-0"
                  onClick={() =>
                    showContent(content === el.line ? "" : el.line)
                  }
                >
                  <p>{el.line}</p>

                  <img
                    style={{ margin: "8px" }}
                    src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                    className={`${content === el.line && style.rotateimg180}`}
                    width="10px"
                    height="10px"
                  />
                </div>
                {content === el.line &&
                  el.docs.map((element, index) => {
                    return showCheckbox === element.title ? (
                      <div
                        key={index}
                        className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
                      >
                        <span className={style.rldownload__agreement}>
                          <input
                            type="checkbox"
                            name="document_read"
                            value={element.title}
                            onClick={() =>
                              handleCheckbox(el.formName, element, index)
                            }
                          />
                          {`I have read and understood the ${element.title
                            .split(" SOP")
                            .shift()} Standard Operating Procedure.`}
                        </span>
                        <button
                          onClick={() => setShowCheckbox(null)}
                          className={`${style.rldownload__button} btn btn-md btn-outline mx-1 mx-sm-0`}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <OnboardingListItem
                        loading={SOPLoading === element.title}
                        title={element.title}
                        status={el.statusFor[element.title] ? 3 : 1}
                        key={index}
                        btnText="Download"
                        disabled={
                          (showCheckbox && showCheckbox.length > 1) ||
                          oldSops[el.line].includes(element.title)
                        }
                        handleClick={(e) =>
                          handleReading(e, element.title, element.link)
                        }
                        downloadingDisabled={true}
                        hideStatus={oldSops[el.line].includes(element.title)}
                      />
                    );
                  })}
              </Fragment>
            ))}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-4">
          <Link to="/profile" className="btn btn-primary px-3">
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

KingspanOnboarding.propTypes = {
  appData: any,
  markDocumentRead: func.isRequired,
  kingspanOnboarding: object,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine1: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine24: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine3: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsShop1: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  kingspanReadingLoading: bool,
  SOPLoading: string,
  postSOPKingspan: func.isRequired,
  kingspanAssessmentLoading: bool,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  kingspanAssessmentLoading: state.core.kingspanAssessment.isLoading,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(KingspanOnboarding);
